import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { PromptsLayoutProps } from "./types";



const PromptsLayout: FC<PromptsLayoutProps> = ({ children, className }) => {
  return (
    <>
      <TopNav title="Prompts" />
      <ContentLayout className={className}>{children}</ContentLayout>
    </>
  );
};

export default PromptsLayout;
